/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './calculation-field.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@angular/forms';
import * as i5 from '../../../../../../app/modules/fields/components/calculation-field/calculation-field.component';
import * as i6 from '@angular/cdk/platform';
const styles_CalculationFieldComponent:any[] = [i0.styles];
export const RenderType_CalculationFieldComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_CalculationFieldComponent,data:{}});
export function View_CalculationFieldComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(1,0,
      (null as any),(null as any),22,'md-form-field',[['class','calculation mat-input-container mat-form-field']],
      [[2,'mat-input-invalid',(null as any)],[2,'mat-form-field-invalid',(null as any)],
          [2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
          [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
              (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
      [[(null as any),'click'],[(null as any),'submit'],[(null as any),'reset']],(_v,
          en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,3)._control.focus()) !== false);
          ad = (pd_0 && ad);
        }
        if (('submit' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,10).onSubmit($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('reset' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,10).onReset()) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i2.View_MdFormField_0,i2.RenderType_MdFormField)),i1.ɵdid(2,16384,(null as any),
      0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(3,7389184,(null as any),6,i3.MdFormField,[i1.ElementRef,
      i1.ChangeDetectorRef,[2,i3.MD_PLACEHOLDER_GLOBAL_OPTIONS]],(null as any),(null as any)),
      i1.ɵqud(335544320,1,{_control:0}),i1.ɵqud(335544320,2,{_placeholderChild:0}),
      i1.ɵqud(603979776,3,{_errorChildren:1}),i1.ɵqud(603979776,4,{_hintChildren:1}),
      i1.ɵqud(603979776,5,{_prefixChildren:1}),i1.ɵqud(603979776,6,{_suffixChildren:1}),
      i1.ɵdid(10,540672,(null as any),0,i4.FormGroupDirective,[[8,(null as any)],[8,
          (null as any)]],{form:[0,'form']},(null as any)),i1.ɵprd(2048,(null as any),
          i4.ControlContainer,(null as any),[i4.FormGroupDirective]),i1.ɵdid(12,16384,
          (null as any),0,i4.NgControlStatusGroup,[i4.ControlContainer],(null as any),
          (null as any)),(_l()(),i1.ɵted(-1,1,['\n  '])),(_l()(),i1.ɵeld(14,0,[['str',
          1]],1,8,'input',[['class','mat-input-element'],['disabled',''],['mdInput',
          '']],[[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
          'aria-describedby',0],[1,'aria-invalid',0],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'change'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i5.CalculationFieldComponent = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,16)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,16).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,16)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,16)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,20)._focusChanged(false)) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,20)._focusChanged(true)) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,20)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('change' === en)) {
          const pd_7:any = ((<any>_co.handleChange(i1.ɵnov(_v,14).value)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(15,16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16,16384,(null as any),0,i4.DefaultValueAccessor,[i1.Renderer2,i1.ElementRef,
          [2,i4.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),i1.ɵprd(1024,
          (null as any),i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i4.DefaultValueAccessor]),i1.ɵdid(18,671744,(null as any),0,i4.FormControlName,
          [[3,i4.ControlContainer],[8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],isDisabled:[1,'isDisabled']},(null as any)),i1.ɵprd(2048,
          (null as any),i4.NgControl,(null as any),[i4.FormControlName]),i1.ɵdid(20,
          933888,(null as any),0,i3.MdInput,[i1.ElementRef,i1.Renderer2,i6.Platform,
              [2,i4.NgControl],[2,i4.NgForm],[2,i4.FormGroupDirective],[2,i3.MD_ERROR_GLOBAL_OPTIONS]],
          {disabled:[0,'disabled']},(null as any)),i1.ɵdid(21,16384,(null as any),
          0,i4.NgControlStatus,[i4.NgControl],(null as any),(null as any)),i1.ɵprd(2048,
          [[1,4]],i3.MdFormFieldControl,(null as any),[i3.MdInput]),(_l()(),i1.ɵted(-1,
          1,['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i5.CalculationFieldComponent = _v.component;
    const currVal_17:any = _co.form;
    _ck(_v,10,0,currVal_17);
    const currVal_31:any = _co.getKey();
    const currVal_32:any = '';
    _ck(_v,18,0,currVal_31,currVal_32);
    const currVal_33:any = '';
    _ck(_v,20,0,currVal_33);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,3)._control.errorState;
    const currVal_1:any = i1.ɵnov(_v,3)._control.errorState;
    const currVal_2:any = i1.ɵnov(_v,3)._control.focused;
    const currVal_3:any = i1.ɵnov(_v,3)._shouldForward('untouched');
    const currVal_4:any = i1.ɵnov(_v,3)._shouldForward('touched');
    const currVal_5:any = i1.ɵnov(_v,3)._shouldForward('pristine');
    const currVal_6:any = i1.ɵnov(_v,3)._shouldForward('dirty');
    const currVal_7:any = i1.ɵnov(_v,3)._shouldForward('valid');
    const currVal_8:any = i1.ɵnov(_v,3)._shouldForward('invalid');
    const currVal_9:any = i1.ɵnov(_v,3)._shouldForward('pending');
    const currVal_10:any = i1.ɵnov(_v,12).ngClassUntouched;
    const currVal_11:any = i1.ɵnov(_v,12).ngClassTouched;
    const currVal_12:any = i1.ɵnov(_v,12).ngClassPristine;
    const currVal_13:any = i1.ɵnov(_v,12).ngClassDirty;
    const currVal_14:any = i1.ɵnov(_v,12).ngClassValid;
    const currVal_15:any = i1.ɵnov(_v,12).ngClassInvalid;
    const currVal_16:any = i1.ɵnov(_v,12).ngClassPending;
    _ck(_v,1,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,
        currVal_14,currVal_15,currVal_16]);
    const currVal_18:any = i1.ɵnov(_v,20).id;
    const currVal_19:any = i1.ɵnov(_v,20).placeholder;
    const currVal_20:any = i1.ɵnov(_v,20).disabled;
    const currVal_21:any = i1.ɵnov(_v,20).required;
    const currVal_22:any = (i1.ɵnov(_v,20)._ariaDescribedby || (null as any));
    const currVal_23:any = i1.ɵnov(_v,20).errorState;
    const currVal_24:any = i1.ɵnov(_v,21).ngClassUntouched;
    const currVal_25:any = i1.ɵnov(_v,21).ngClassTouched;
    const currVal_26:any = i1.ɵnov(_v,21).ngClassPristine;
    const currVal_27:any = i1.ɵnov(_v,21).ngClassDirty;
    const currVal_28:any = i1.ɵnov(_v,21).ngClassValid;
    const currVal_29:any = i1.ɵnov(_v,21).ngClassInvalid;
    const currVal_30:any = i1.ɵnov(_v,21).ngClassPending;
    _ck(_v,14,1,[currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,
        currVal_24,currVal_25,currVal_26,currVal_27,currVal_28,currVal_29,currVal_30]);
  });
}
export function View_CalculationFieldComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-calculation-field',
      ([] as any[]),[[2,'not-required',(null as any)]],(null as any),(null as any),
      View_CalculationFieldComponent_0,RenderType_CalculationFieldComponent)),i1.ɵdid(1,
      49152,(null as any),0,i5.CalculationFieldComponent,([] as any[]),(null as any),
      (null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).isNotRequired;
    _ck(_v,0,0,currVal_0);
  });
}
export const CalculationFieldComponentNgFactory:i1.ComponentFactory<i5.CalculationFieldComponent> = i1.ɵccf('app-calculation-field',
    i5.CalculationFieldComponent,View_CalculationFieldComponent_Host_0,{editable:'editable',
        form:'form',fieldValue:'fieldValue'},{fieldValueChange:'fieldValueChange',
        edited:'edited'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/fields/components/calculation-field/calculation-field.component.ngfactory.ts